import styled from 'styled-components';

import colors from '../../../../styles/colors';
import { ReactComponent as StopIcon } from '../../../../assets/icons/stop-icon.svg';

const RecordingView = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  padding-right: 12px;
  font-size: 14px;
  color: ${colors.base.secondary2};
`;

const RecordingLabel = styled.div`
  display: flex;
  margin-left: 10px;
  flex-direction: row;
  align-items: center;
  flex: 1;
  column-gap: 5px;
`;

const StyledStopIcon = styled(StopIcon)`
  display: flex;
  height: 20px;
  width: 20px;
  color: ${colors.shades.danger1};
  margin-left: 2px;
`;

export {
  RecordingView,
  RecordingLabel,
  StyledStopIcon,
};
